var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVaultDisabled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CBD6",
    fillRule: "evenodd",
    d: "M3.333 11.463v3.594c0 .198.187.36.417.36h12.5c.23 0 .416-.162.416-.36V7.899c0-.2-.186-.36-.416-.36H10c-.25 0-.487-.113-.645-.307L7.188 4.584H3.75c-.23 0-.417.16-.417.359v6.52zm12.917 5.62H3.75c-1.148 0-2.083-.909-2.083-2.026V4.943c0-1.118.935-2.026 2.083-2.026h3.834c.25 0 .487.112.645.306l2.166 2.649h5.855c1.148 0 2.083.908 2.083 2.027v7.158c0 1.117-.935 2.027-2.083 2.027z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVaultDisabled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vault_disabled.e3ddad2b.svg";
export { ForwardRef as ReactComponent };